
import { defineComponent, onMounted, ref } from 'vue'

export default defineComponent({
  props: {
    id: { type: [String, Number], required: true },
    name: { type: String, required: true },
    externalIndex: { type: Number, default: 0 }
  },
  emits: ['save', 'cancel'],
  setup(props, { emit }) {
    const value = ref(props.name)
    const folderNameInput = ref()

    onMounted(() => folderNameInput.value.focus())

    const saveHandler = () => {
      props.name === value.value ? emit('cancel') : emit('save', value.value)
    }

    return { value, folderNameInput, saveHandler }
  }
})
